import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

export const getResourceTypesAutoria = async () => {
    const { data } = await axios.get(API_ROUTES.RESOURCES_TYPE, { params: { category: 'autoria'} });
    return data;
};

export const getResourceTypesVideo = async () => {
    const { data } = await axios.get(API_ROUTES.RESOURCES_TYPE, { params: { category: 'video'} });
    return data;
};